<template>
  <div class="page-background-new">
    <div v-show="cardList.length" style="text-align: center">
      <div class="escortpepole-header-view" @click="toAdd">
        <div>新增患者&nbsp;</div>
        <img :src="require('@assets/ic_cardpackage_add.png')" alt="" />
      </div>
      <div
        style=" color: #fff;font-weight: 400;font-size: 0.56rem;font-family: PingFang SC, sans-serif"
      >
        注: 此入口为新增非当前患者的陪护信息
      </div>
    </div>
    <div
      v-show="cardList.length"
      style="height: 10rem; margin: 1rem 1rem 0 1rem; background: #09f; border-radius: 0.67rem"
    >
      <div
        class="user-info"
        :style="!list.length ? 'border-radius: 0.67rem 0.67rem 0 0' : ''"
      >
        <!-- <img :class="sexClass" :src="require('@assets/ic_user_portrait.png')" alt="" /> -->
        <div :class="sexClass"></div>
        <div style="line-height: 1.7rem">
          <div class="user-info-name">
            {{ userInfo.patientName }}
          </div>
          <div class="user-info-card-no" style="font-size: 0.87rem">
            住院号:
            {{ userInfo.patientCardNo }}
          </div>
          <div class="user-info-card-no" style="font-size: 0.87rem">
            病区:
            {{ userInfo.inpatientWard }}
          </div>
          <div class="user-info-card-no" style="font-size: 0.87rem">
            床号:
            {{ userInfo.berthNo }}
          </div>
        </div>
        <div class="card-type" @click="showCard = true">
          <van-icon name="arrow-down" color="white" />
          <!-- <img style="width: 4.66rem;height: 2rem;background: #FFFFFF;border: 0px solid #FFFFFF;border-radius: 1rem;"
        :src="require('@assets/icon_change.png')" alt="" /> -->
        </div>
      </div>
    </div>
    <div
      class="escortpeopleInfo"
      :style="cardList.length ? '' : 'margin-top:1rem'"
    >
      <div
        v-for="(item, index) in list"
        v-show="list.length"
        :key="index"
        class="escortpeopleInfo-box"
      >
        <div
          class="escortpeopleInfo-box-title"
          :style="
            item.startStatus == '2' && item.auditStatus == '1'
              ? 'background: #EFEFEF;'
              : 'background: #ECF9FF;color: #0099FF;'
          "
        >
          <div class="escortpeopleInfo-box-title-lable">添加时间</div>
          <div class="escortpeopleInfo-box-title-value">
            {{ item.createTime }}
          </div>
        </div>
        <div class="escortpeopleInfo-box-info">
          <img
            class="escortpeopleInfo-box-info-photo"
            :src="
              item.headImgUrl
                ? item.headImgUrl
                : require('@assets/ic_user_portrait_common.png')
            "
            @click="showPh(item)"
          />
          <div style="line-height: 1.7rem">
            <div style="display: flex">
              <div
                class="escortpeopleInfo-box-info-name"
                :style="
                  item.startStatus == '2' && item.auditStatus == '1'
                    ? 'color: #999999;'
                    : ''
                "
              >
                {{ item.name }}
              </div>
              <div
                class="escortpeopleInfo-box-info-statusName"
                :style="forMaterStatus(item).color"
              >
                {{ item.statusName }}
              </div>
            </div>
            
            <div
                class="escortpeopleInfo-box-info-reason"
                :style="forMaterStatus(item).color"
              >
                {{ item.context && item.auditStatus == 2 ?'拒绝原因：'+ item.context : '' }}
              </div>
            <div
              class="escortpeopleInfo-box-info-idCard"
              :style="
                item.startStatus == '2' && item.auditStatus == '1'
                  ? 'color: #999999;'
                  : ''
              "
            >
              {{ formIdCard(item.idCard) }}
            </div>
          </div>
          <div
            v-show="
              item.startStatus == 1 && item.auditStatus == '1' ? true : false
            "
            style="position: absolute; right: 1rem; font-size: 0"
            @click="showPopup(item)"
          >
            <img :src="require('@assets/icon_qr.png')" style="width: 2rem" />
          </div>
          <div
            v-show="
              item.startStatus == 2 && item.auditStatus == '1' ? true : false
            "
            style="position: absolute; right: 1rem; font-size: 0"
          >
            <img :src="require('@assets/icon_delqr.png')" style="width: 2rem" />
          </div>
        </div>
        <div>
          <div
            v-if="item.auditStatus == '0' && item.startStatus == '0'"
            style="display: flex; margin: 0 1rem;padding-bottom: 2rem"
          >
            <ph-button
              class="ph-button"
              style="color:black;background: #F7F8FA;border: 1px solid #D8D8D8;"
              @click="delEscort(item)"
            >
              删除陪护
            </ph-button>
            <ph-button
              class="ph-button"
              style="background: #09F;"
              @click="toDetail(item)"
            >
              修改陪护
            </ph-button>
          </div>
          <div
            v-if="item.auditStatus == '2' && item.startStatus == '0'"
            style="display: flex; margin: 0 1rem;padding-bottom: 2rem"
          >
            <ph-button
              class="ph-button"
              style="color:black;background: #F7F8FA;border: 1px solid #D8D8D8;"
              @click="delEscort(item)"
            >
              删除陪护
            </ph-button>
            <ph-button
              class="ph-button"
              style="background: #09F;"
              @click="toDetail(item)"
            >
              修改陪护
            </ph-button>
          </div>
          <div
            v-if="item.auditStatus == '1' && item.startStatus == '1'"
            style="display: flex; margin: 0 1rem;padding-bottom: 2rem"
          >
            <div
              style="
                width: 50%;
                color: #fe5546;
                font-weight: 400;
                font-size: 0.88rem;
                font-family: PingFang SC, sans-serif;
                line-height: 2.5rem;
              "
            >
              * 凭证有效期:余{{ item.dayCount }}天
            </div>
            <ph-button
              class="ph-button"
              style="background: #09F;"
              @click="stopEscort(item)"
            >
              停止陪护
            </ph-button>
          </div>
          <div
            v-if="
              (item.auditStatus == '1' && item.startStatus != '1') ||
                (item.auditStatus == '3' && item.startStatus != '1')
            "
            style="display: flex; margin: 0 1.5rem; padding-bottom: 2rem"
          >
            <ph-button
              class="ph-button"
              style="color:black;background: #F7F8FA;border: 1px solid #D8D8D8;"
              @click="delEscort(item)"
              >删除陪护</ph-button
            >
            <ph-button
              class="ph-button"
              style=" background: #09F; "
              @click="startEscort(item)"
              >启动陪护</ph-button
            >
          </div>
        </div>
      </div>
      <div v-show="!list.length" class="empty-view" style="background: white">
        <img :src="require('@assets/icon_emty.png')" alt="" />
        <div style=" padding-top: 0.59rem;font-size: 1.133rem" class="">
          当前住院号暂未绑定陪护人员
        </div>
      </div>
    </div>
    <div class="tip-wrap">
      <div class="tip-title">陪护须知:</div>
      <ul class="message-list">
        <li>病区陪护者，一患一陪。</li>
        <li>电子陪护证限本人使用，进入医院及科室请配合出示电子陪护证。</li>
        <li>病区内戴口罩，不串病房，门禁关闭期间勿进出。</li>
        <li>超过有效期前请及时重新采集核酸并再次申请新的电子陪护证。</li>
        <li>
          请认真阅读及正确填写信息，信息必须真实有效，如有虚假，则由申请人承担全部责任。
        </li>
      </ul>
    </div>
    <ph-button
      :style="
        'border-radius: 2rem;margin: 1.88rem auto;background: #0099FF;height: 3.6rem;'
      "
      @click="toAdd(1)"
    >
      立即添加陪护人员
    </ph-button>
    <van-popup
      v-model="showCode"
      style="
        padding: 1rem;
        color: #333;
        font-size: 1.13rem;
        line-height: 1.5rem;
        text-align: center;
        border-radius: 1rem;
      "
    >
      <div style="text-align: center" @click="showCode = false">
        <div>{{ name }}</div>
        <div>{{ idCard }}</div>
        <VueQrcode :value="qrcodeStr" :options="{ width: 300, margin: 1 }" />
        <div style="color: #999; font-size: 1rem">长按二维码</div>
      </div>
    </van-popup>
    <van-popup v-model="showCard" round position="bottom">
      <van-picker
        show-toolbar
        :columns="cards"
        @cancel="showCard = false"
        @confirm="cardConfirm"
      />
    </van-popup>
    <van-popup
      v-model="showPhoto"
      style=" width: calc(100% - 6rem);text-align: center; border-radius: 1rem"
    >
      <img
        :src="photo ? photo : require('@assets/ic_user_portrait_common.png')"
        style="width: 100%"
        alt=""
      />
    </van-popup>
  </div>
</template>
<script>
import PhButton from "@/components/PhButton.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
export default {
  components: { PhButton, VueQrcode },
  data() {
    return {
      userInfo: {},
      ftype: "2",
      qrtype: "1",
      list: [],
      startCount: 0,
      showCode: false,
      qrcodeStr: "",
      name: "",
      idCard: "",
      cardList: [],
      showCard: false,
      showPhoto: false,
      photo: ""
    };
  },
  computed: {
    sexClass() {
      var sex = 0;
      if (this.userInfo && this.userInfo.idCard) {
        const value = this.userInfo.idCard;
        if (value.length === 15) {
          sex = value.substr(14, 1) % 2 || 2;
        }
        if (value.length === 18) {
          sex = value.substr(16, 1) % 2 || 2;
        }
      }
      if (sex == 1) {
        return "user-info-portrait-man";
      } else if (sex == 2) {
        return "user-info-portrait-woman";
      }
      return "user-info-portrait";
    },
    cards() {
      return this.cardList.map(item => {
        return {
          text: item.patientName + " " + item.patientCardNo,
          ...item
        };
      });
    }
  },
  created() {
    this.setBaseFontSize();
    //this.$http
    //  .post(this.$api.USER_BASE_INFO, {
    //    functionType: this.ftype,
    //    eleFlag: this.qrtype === "2" ? "1" : "0",
    //  })
    //  .then((res) => {
    //    this.userInfo = res;
    //  });
    this.getCardList();
    //this.getList();
  },
  mounted() {
    this.setBaseFontSize();
  },
  beforeDestroy() {
    let htmlDom = document.getElementsByTagName("html")[0];
    htmlDom.style.fontSize = "";
  },
  methods: {
    // 查看
    toDetail(item) {
      if (item.auditStatus === "0" || item.auditStatus === "2") {
        this.$router.push({
          path: "/escortpeople/add",
          query: {
            ...item,
            functionType: "2",
            cardNo: item.patientCardNo, // 病人卡号
            flag: "edit",
            isAuditing: 1 // 审核中..
          }
        });
      }
    },
    setBaseFontSize() {
      /*上面设置font-size的代码*/
      let htmlWidth =
        document.documentElement.clientWidth || document.body.clientWidth; // 获取宽度最好有个兼容的方案，避免某些情况下第一种获取不到可以选择第二种
      //获取html
      let htmlDom = document.getElementsByTagName("html")[0];
      htmlDom.style.fontSize = htmlWidth > 640 ? "16px" : htmlWidth / 25 + "px";
    },
    formIdCard(idCard) {
      let card = "";
      if (idCard) {
        card = idCard.substr(0, 6) + "*****" + idCard.substr(idCard.length - 4);
      }
      return card;
    },
    getCardList() {
      this.$http
        .post(this.$api.ESCORTPEOPLE_CARD_LIST, {
          functionType: this.ftype
        })
        .then(res => {
          this.cardList = res;
          if (this.cardList.length) {
            this.userInfo = res[0];
            this.getList(this.userInfo.patientCardNo);
          }
        });
    },
    toCardList() {
      this.$router.push({
        path: "/user/components/changecardview?ftype=2"
      });
    },
    toAdd(type) {
      if (type == 1) {
        if (this.startCount >= 2) {
          this.$toast("该住院号已存在2位陪护中或审核中的人员");
          return false;
        }
        this.$router.push({
          path: "/escortpeople/survey",
          query: {
            cardNo: this.userInfo.patientCardNo
          }
        });
      } else {
        this.$router.push({
          path: "/escortpeople/survey"
        });
      }
    },
    getList(cardNo) {
      this.startCount = 0;
      this.$http
        .post(this.$api.ESCORTPEOPLE_LIST, {
          functionType: this.ftype,
          cardNo: cardNo
        })
        .then(res => {
          this.list = res.map(item => {
            if (
              (item.startStatus == "1" && item.auditStatus == "1") ||
              item.auditStatus == "0"
            ) {
              this.startCount = this.startCount + 1;
            }
            // let dateCount = this.$moment(item.detectionTime).diff(this.$moment(new Date()), "days");
            return {
              ...item,
              statusName: this.forMaterStatus(item).statusName
              // dateCount
            };
          });
        });
    },
    showPopup(item) {
      if (item.expiringOrExpired) {
        this.showTip(item);
      } else {
        this.showQrcode(item);
      }
    },
    showQrcode(item) {
      this.qrcodeStr = item.qrCode;
      this.name = item.name;
      this.idCard = item.idCard;
      if (this.qrcodeStr != "") {
        this.showCode = true;
      } else {
        this.$toast("二维码未生成...");
      }
    },
    // 凭证失效提示
    showTip(item) {
      this.$dialog
        .confirm({
          className: "dialog_expire",
          message: `当前陪护凭证剩余有效期${item.dayCount}天，即将过期，请尽快更新核酸报告后重新发起申请！点击确定可前往上传核酸报告等信息。`
        })
        .then(() => {
          this.$router.push({
            path: "/escortpeople/add",
            query: {
              ...item,
              functionType: "2",
              cardNo: item.patientCardNo, // 病人卡号
              flag: "edit"
            }
          });
        })
        .catch(() => {
          this.showQrcode(item);
        });
    },
    showPh(item) {
      this.photo = item.headImgUrl;
      this.showPhoto = true;
    },
    forMaterStatus(item) {
      let statusName = "";
      let color = "color:#FE5546;";
      if (item.auditStatus == "1") {
        if (item.startStatus == "0") {
          statusName = "待启动";
          color = "color:#999999;";
        } else if (item.startStatus == "1") {
          statusName = "陪护中";
          color = "color:#0099FF;";
        } else if (item.startStatus == "2") {
          statusName = "已停止陪护";
          color = "color:#999999;";
        }
      } else if (item.auditStatus === "0") {
        statusName = "审核中";
      } else if (item.auditStatus === "3") {
        statusName = "";
      }else if (item.auditStatus === "2") {
        statusName = "已拒绝";
      }
      return { statusName, color };
    },
    startEscort(item) {
      if (this.startCount >= 2) {
        this.$toast(
          "该住院号已存在2位陪护中或审核中的人员，请停止一位再尝试启动!"
        );
        return false;
      }
      this.$http.post(this.$api.ESCORTPEOPLE_START, item).then(() => {
        this.$toast("启动成功，请等待工作人员审核!");
        this.getList(this.userInfo.patientCardNo);
      });
    },
    stopEscort(item) {
      this.$dialog
        .confirm({
          message: "是否确认停止该陪护，重新启动需等待后台审核，请确认!"
        })
        .then(() => {
          this.$http.post(this.$api.ESCORTPEOPLE_STOP, item).then(() => {
            this.getList(this.userInfo.patientCardNo);
          });
        })
        .catch(() => {});
    },
    delEscort(item) {
      this.$dialog
        .confirm({
          message: "是否确认删除该陪护，重新添加需要后台审核"
        })
        .then(() => {
          this.$http.post(this.$api.ESCORTPEOPLE_DEL, item).then(() => {
            this.$toast("删除成功!");
            this.getList(this.userInfo.patientCardNo);
          });
        })
        .catch(() => {});
    },
    cardConfirm(v) {
      this.userInfo = {
        ...v
      };
      this.showCard = false;
      this.getList(this.userInfo.patientCardNo);
    }
  }
};
</script>
<style lang="less" scoped>
.tip-wrap {
  padding: 1.2rem;
  color: red;
  font-size: 0.88rem;
  .tip-title {
    margin-bottom: 1.2rem;
    color: #fe5546;
    font-weight: 500;
    font-size: 1.13rem;
  }
  .message-list {
    color: #fe5546;
    font-weight: 400;
    font-size: 0.87rem;
    line-height: 1.47rem;
    li {
      padding-left: 0.8rem;
      list-style-type: none;
      background: url("~@/assets/icon_diamond.png") no-repeat 0 0.4rem;
      background-size: 0.5rem 0.5rem;
    }
  }
}
.escortpepole-header-view {
  display: flex;
  align-items: center;
  margin: 1.31rem 0 0.75rem 0;
  color: white;
  font-weight: 600;
  font-size: 1.31rem;
  font-family: PingFang SC, sans-serif;
  text-align: center;
  > div {
    width: 56%;
    margin-right: 0.7rem;
    text-align: right;
  }
  img {
    width: 1.57rem;
    height: 1.57rem;
  }
}
.user-info {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem 1.37rem;
  color: white;
  &-portrait {
    width: 3.73rem;
    height: 3.73rem;
    margin-right: 0.87rem;
    background-image: url("~@/assets/ic_user_portrait_common.png");
    background-repeat: no-repeat;
    background-size: 3.37rem;

    &-man {
      width: 3.73rem;
      height: 3.73rem;
      margin-right: 0.87rem;
      background-image: url("~@/assets/ic_user_portrait_man.png");
      background-repeat: no-repeat;
      background-size: 3.73rem;
    }
    &-woman {
      width: 3.73rem;
      height: 3.73rem;
      margin-right: 0.87rem;
      background-image: url("~@/assets/ic_user_portrait_woman.png");
      background-repeat: no-repeat;
      background-size: 3.73rem;
    }
  }
  .card-type {
    // margin-right: 1rem;
    position: absolute;
    //top: 1.88rem;
    right: 1.25rem;
    margin-left: auto;
    //padding: 0 0.77rem;
    //color: #09f;
    //font-size: 1rem;
    //background-color: white;
    //border: solid 0.03rem #fff;
    //border-radius: 0.935rem;
  }
}
.escortpeopleInfo {
  position: relative;
  margin: -1rem 1rem 1rem 1rem;
  overflow: scroll;
  background-color: white;
  border-radius: 1rem;
  &-box {
    margin: 1rem 1rem 1.33rem 1rem;
    background: white;
    border-radius: 1rem;
    box-shadow: 0 0.4rem 0.86rem 0 rgba(228, 228, 228, 0.6);
    &-title {
      display: flex;
      padding: 0.92rem 1.03rem;
      font-weight: 500;
      font-size: 0.81rem;
      font-family: PingFang SC, sans-serif;
      border-radius: 1rem 1rem 0 0;
      &-value {
        position: absolute;
        right: 2rem;
      }
    }
    &-info {
      position: relative;
      display: flex;
      align-items: center;
      padding: 1.33rem 1rem 1.66rem 1rem;
      &-photo {
        width: 3.66rem;
        height: 3.66rem;
        margin-right: 0.87rem;
        border-radius: 50%;
      }
      &-name {
        color: #333;
        font-weight: 500;
        font-size: 1.07rem;
      }
      &-statusName {
        margin-left: 0.83rem;
        font-weight: 400;
        font-size: 0.93rem;
        line-height: 1.6rem;
      }
      &-idCard {
        color: #666;
        font-weight: 400;
        font-size: 0.93rem;
      }
    }
  }
  .empty-view {
    position: relative;
    z-index: 1000;
    display: block;
    width: 100%;
    height: 100%;
    height: 25.44rem;
    text-align: center;
    border-radius: 1rem;
    img {
      width: 50%;
      height: auto;
      margin-top: 6.66rem;
    }
  }
}
.ph-button {
  width: 8rem;
  height: 2.6rem;
  font-size: 1rem;
  line-height: 2.5rem;
  border-radius: 2rem;
}
</style>
<style>
.dialog_expire {
  color: red;
}
</style>
